import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 10 * 60 * 1000,
      retry: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: true, 
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
